import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/FetchOrganizationList";

export function* fetchOrganizationList(action: Actions.FetchOrganizationListAction) {
    const { credentials } = action.payload;

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });

        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const orgs = yield api.getOrgs();
        yield put(Actions.fetchOrganizationListEnd(undefined, orgs));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.fetchOrganizationListEnd(e, []));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchFetchOrganizationList() {
    yield takeEvery(Actions.FETCH_ORGANIZATION_LIST, fetchOrganizationList);
}
